// extracted by css-extract-rspack-plugin
export default {"catalogLinks":"catalog-links--gXdennhLqgUvr21D","catalogLink":"catalog-link--aROMclTYQygE3St1"};